import { DataWithPagination } from "services/api/types";
import { PaginationDirection } from "services/url";

export const initialOfferSaleDataWithPagination: DataWithPagination = {
  pagination: {
    pageNumber: 1,
    pageSize: 5,
    sort: {
      sortBy: "created",
      direction: PaginationDirection.Descending,
    },
    totalCount: 0,
    totalPages: 0,
  },
  data: [],
};
